import React, { ReactNode, useMemo } from "react";
import { FeatureToggleContext } from "./FeatureToggleContext";

type FeatureToggleProps = {
  children: ReactNode;
  disabledFeatures: string[];
};

export const FeatureToggle = ({
  children,
  disabledFeatures,
}: FeatureToggleProps) => {
  // Memoize the context value
  const contextValue = useMemo(() => ({ disabledFeatures }), [disabledFeatures]);

  return (
    <FeatureToggleContext.Provider value={contextValue}>
      {children}
    </FeatureToggleContext.Provider>
  );
};
